export default __webpack_public_path__ + "be3eb7aab3734d36ba9b65665462f884.svg";